import {
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC, useCallback, useEffect, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { private_function } from '../../assets/base64';
import { Image } from '../../components/Image';
import { STYLE_VARS } from '../../constants/style-vars';
import BookingPrivateForm from './components/BookingPrivateForm';
import { Footer } from '../../components/Footer';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { DinningLayout } from '../../WebLayout';
import { FONTS } from '../../constants';
import { IFormData } from '../../components/FormHelper/FormHelper.types';
import DiningApi from '../../services/api/dining.api';
import { Alert } from '../../services/alert';
import { Loading } from '../../components';
import OptionsApi from '../../services/api/options.api';

const PrivateFunction: FC = () => {
  const isDesktop = useIsDesktop();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [banner, setBanner] = useState<string>();
  const [isLoadingBanner, setIsLoadingBanner] = useState<boolean>(true);

  const onSubmitHandler = useCallback(async (data: IFormData) => {
    setIsLoading(true);
    const submitData = {
      date: `${data.date} ${data.time}:00`,
      venue: data.venue,
      type: data.type,
      attendees: data.nPeople,
      comments: data.request,
    };
    let bookingInfo = `Thank you for your reservation! We have received your enquiry and a confirmation email will be sent to you shortly. If you do no hear with us within 24 hours, you may contact us directly at Ph. 3473 7169. Venue: ${data.venue}  Date & Time: ${data.date} ${data.time}:00 Duration: 1 hour`;

    DiningApi.postPrivateFunctionRequest(submitData)
      .then((res) => {
        Alert.alert('Success', bookingInfo);
      })
      .catch((error) => {
        Alert.alert('Booking Alert', error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const getBanner = useCallback(async () => {
    try {
      setIsLoadingBanner(true);
      const res = await OptionsApi.getOptions();
      setBanner(res.data.fields.private_function_banner?.url);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoadingBanner(false);
    }
  }, []);

  useEffect(() => {
    getBanner();
  }, [getBanner]);

  if (isDesktop()) {
    return (
      <DinningLayout
        title="Book A Private Function"
        icon={
          IS_WEB
            ? addBase64Prefix(private_function)
            : require('../../assets/private-function.png')
        }
        current={1}
      >
        <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
          <Image
            source={{
              uri: banner,
            }}
            style={{
              width: 400,
              height: 230,
              resizeMode: 'cover',
              marginRight: 20,
            }}
          />
          <View>
            <TouchableOpacity
              style={{
                alignSelf: 'flex-start',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Image
                source={require('../../assets/dining-menus.png')}
                style={styles.menuIcon}
              />
              <Text
                style={[
                  styles.text,
                  { marginTop: 13, textDecorationLine: 'underline' },
                ]}
              >
                View Menu
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={{ marginTop: 20 }}>
          <BookingPrivateForm onSubmitHandler={onSubmitHandler} />
        </View>
        {isLoading === true && <Loading isFullScreen={true} />}
      </DinningLayout>
    );
  }
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Book Private Event"
          icon={
            IS_WEB
              ? addBase64Prefix(private_function)
              : require('../../assets/private-function.png')
          }
          haveGoBackButton={true}
        />
      </View>
      <View style={styles.container}>
        <Image
          source={{
            uri: banner,
          }}
          style={{
            width: '100%',
            height: 230,
            resizeMode: 'cover',
          }}
        />
      </View>
      <View style={styles.container}>
        <TouchableOpacity
          style={{
            alignSelf: 'flex-start',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Image
            source={require('../../assets/dining-menus.png')}
            style={[styles.menuIcon, { marginVertical: 20 }]}
          />
          <Text
            style={[
              styles.text,
              { marginTop: 13, textDecorationLine: 'underline' },
            ]}
          >
            View Menu
          </Text>
        </TouchableOpacity>
      </View>
      <View style={styles.container}>
        <BookingPrivateForm onSubmitHandler={onSubmitHandler} />
      </View>
      <Footer />
      {isLoading === true && <Loading isFullScreen={true} />}
    </ScrollView>
  );
};

export default PrivateFunction;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  text: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 14,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  menuIcon: {
    width: 20,
    height: 28,
    resizeMode: 'contain',
    tintColor: STYLE_VARS.primaryColor,
    marginRight: 5,
  },
});
